import * as React from "react";

import { IconButton, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { InfoDialog } from "./InfoDialog";
import { IButtonProps } from "./IButtonProps";

import { Analytics } from "Utility/Analytics";

export function InfoButton(props: IButtonProps): React.ReactElement {
    const [show, setShow] = React.useState(false);
    const quiltRenderData = props.quiltRenderData;
    const disabled = quiltRenderData === null || props.disabled;

    const onClick = () => {
        Analytics.showQuiltInfo(props.quiltRenderData!.code);
        setShow(true);
    };

    return (
        <>
           <Tooltip title="Quilt info">
               <span>
                    <IconButton size="small" color="primary" onClick={onClick} disabled={disabled}>
                        <InfoOutlinedIcon/>
                    </IconButton>
               </span>
            </Tooltip>
            {quiltRenderData !== null && show &&
                <InfoDialog
                    onClose={() => setShow(false)}
                    quiltRenderData={quiltRenderData} />
            }
        </>
    )
}